import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { useSiteSettings } from '../SiteSettingsContext';
import { getMergedStoreCopy } from '../storeCopy';

export default function CheckoutProgress({ current = 'cart' }) {
  const { settings: site } = useSiteSettings();
  const store = getMergedStoreCopy(site);
  const steps = useMemo(
    () => [
      { key: 'cart', label: store.checkout_progress_cart, to: '/cart' },
      { key: 'checkout', label: store.checkout_progress_details, to: '/checkout' },
      { key: 'pay', label: store.checkout_progress_payment, to: null },
    ],
    [
      store.checkout_progress_cart,
      store.checkout_progress_details,
      store.checkout_progress_payment,
    ]
  );
  const idx = steps.findIndex((s) => s.key === current);

  return (
    <nav className="checkout-progress" aria-label="Checkout progress">
      <ol className="checkout-progress__list">
        {steps.map((step, i) => {
          const done = i < idx;
          const active = i === idx;
          const upcoming = i > idx;
          const content = (
            <>
              <span className="checkout-progress__dot" aria-hidden>
                {done ? '✓' : i + 1}
              </span>
              <span className="checkout-progress__label">{step.label}</span>
            </>
          );
          return (
            <li
              key={step.key}
              className={`checkout-progress__step${active ? ' checkout-progress__step--active' : ''}${
                done ? ' checkout-progress__step--done' : ''
              }${upcoming ? ' checkout-progress__step--upcoming' : ''}`}
              aria-current={active ? 'step' : undefined}
            >
              {step.to && (done || (active && step.key === 'cart')) ? (
                <Link to={step.to} className="checkout-progress__link">
                  {content}
                </Link>
              ) : (
                <span className="checkout-progress__link checkout-progress__link--static">{content}</span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
